// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

// users.js
export const UPDATE_USERS = 'UPDATE_USERS'
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE'
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS'
export const FETCH_ROLES_FAILURE = 'FETCH_ROLES_FAILURE'
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE'
export const RESET_USER_FORM_ERRORS = 'RESET_USER_FORM_ERRORS'
export const FETCH_EDIT_USER_SUCCESS = 'FETCH_EDIT_USER_SUCCESS'
export const FETCH_EDIT_USER_FAILURE = 'FETCH_EDIT_USER_FAILURE'
export const PATCH_USER_FAILURE = 'PATCH_USER_FAILURE'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_SORT_DESC = 'SET_SORT_DESC'
export const SET_FILTERS = 'SET_FILTERS'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'

// content.js
export const FETCH_CONTENT_SUCCESS = 'FETCH_CONTENT_SUCCESS'
export const FETCH_HAZARDS_SUCCESS = 'FETCH_HAZARDS_SUCCESS'
export const CONTENT_FAILURE = 'CONTENT_FAILURE'
export const FETCH_ATTR_SUCCESS = 'FETCH_ATTR_SUCCESS'
export const DELETE_CONTENT_SUCCESS = 'DELETE_CONTENT_SUCCESS'
export const UPDATE_CONTENT_SUCCESS = 'UPDATE_CONTENT_SUCCESS'
export const FETCH_ORGANISATIONS_SUCCESS = 'FETCH_ORGANISATIONS_SUCCESS'
export const FETCH_ORGANISATION_SINGLE_SUCCESS = 'FETCH_ORGANISATION_SINGLE_SUCCESS'
export const FETCH_INSTRUCTION_SUCCESS = 'FETCH_INSTRUCTION_SUCCESS'
export const FETCH_REGIONS_SUCCESS = 'FETCH_REGIONS_SUCCESS'
export const SET_CURRENT_LANGUAGES = 'SET_CURRENT_LANGUAGES'

// generic.js
export const NETWORK_FAILURE = 'NETWORK_FAILURE'

// apps.js
export const FETCH_APPS_SUCCESS = 'FETCH_APPS_SUCCESS'
export const FETCH_APP_SUCCESS = 'FETCH_APP_SUCCESS'

// audit.js
export const FETCH_AUDITS_SUCCESS = 'FETCH_AUDITS_SUCCESS'

// terms.js
export const FETCH_TERMS_SUCCESS = 'FETCH_TERMS_SUCCESS'
export const FETCH_ALL_TERMS_SUCCESS = 'FETCH_ALL_TERMS_SUCCESS'
export const FETCH_LATEST_TERM_SUCCESS = 'FETCH_LATEST_TERM_SUCCESS'

// usage.js
export const FETCH_APPLICATION_USAGE_SUCCESS = 'FETCH_APPLICATION_USAGE_SUCCESS'
export const FETCH_ENDPOINT_USAGE_SUCCESS = 'FETCH_ENDPOINT_USAGE_SUCCESS'
export const FETCH_CUMULATIVE_USAGE_SUCCESS = 'FETCH_CUMULATIVE_USAGE_SUCCESS'
